import React, {PureComponent, Fragment} from 'react';
import PublicHeader from './../../components/header/index';
import Action from './../action';
import './index.scss';
import {connect} from 'react-redux';
import {getPayParams, getUserInfo} from './store/actionCreators';
import {Toast, Radio, List} from 'antd-mobile';
import history from './../../utils/history';
import {Icon} from 'antd';
import '../../utils/storage';

const RadioItem = Radio.RadioItem;


class PayOrder extends PureComponent {


    constructor(props) {
        super(props);

        this.state = {
            value: 3,
            data: [{value: 3, label: '微信支付'}],
        };

        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (!oauthInfo) {
            history.push('./login');
            return;
        }
        if (oauthInfo.type === 3) {
            this.state.data.push({value: 1, label: '会员卡支付'})
        }

        console.log(this.state.data)
    }

    componentDidMount() {
        // 监听浏览器点击返回
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.handleBack, false);
        }
    }

    // 页面销毁取消监听
    componentWillUnmount() {
        window.removeEventListener('popstate', this.handleBack, false);
    };

    handleBack() {
        history.push('./home');
    }

    async handlePayOrder() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }

        const {orderId = 0} = this.props.location.state;

        const {value} = this.state;

        let data = {};//encodeURIComponent(`${token}|${OrderAmount}|${openId}|${SONumber}|${OrderNumber}|${ProviderId}`);

        // 支付方式，0，微信支付|1.会员支付
        var payType = value;

        const result = await this.props.handleWechatPay(data, payType, orderId, oauthInfo.id);

        if (result.status === 200 && result.data.data) {
            if (payType === 1) {
                Toast.success('支付成功');
                history.replace('/paySuccess');
            } else {
                window.WeChatPay.Base.getInstance().WeChatPay(result.data.data, this.HandlePayCallBack);
            }
        } else {
            Toast.info("发起支付异常!");
            history.replace('/myOrder');
        }
    }

    HandlePayCallBack(res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
            Toast.success('支付成功');
            history.replace('/paySuccess');
        }
        else {
            history.replace('/myOrder');
            Toast.success('支付已取消!');
        }
    }

    onChange = (value) => {
        this.setState({
            value,
        });
    };

    render() {
        const {value, data} = this.state;
        const {state} = this.props.location;
        const {orderId, price} = state;
        console.log('data', data);
        return (
            <Fragment>
                <PublicHeader title="收银台"/>

                <List>
                    {data.map(i => (
                        <RadioItem key={i.value} checked={value === i.value} onChange={() => this.onChange(i.value)}>
                            {i.label}
                        </RadioItem>
                    ))}
                </List>

                <Action text="付款" price={price / 100} HandleSubmitOrder={() => {
                    this.handlePayOrder()
                }}/>
            </Fragment>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleWechatPay: (data, payType, orderId, userId) => dispatch(getPayParams({
            payType: payType,
            orderId: orderId,
            payMethod: 'WeChatJs',
            userId: userId
        })),
        getUserInfo: (id) => dispatch(getUserInfo({userId: id})),
    }
};

export default connect(null, mapDispatchToProps)(PayOrder);
